// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, GithubAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDdVo6aApczFp6-ZzLTLhKiIaUR_271uEg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "nkenneai-c6551.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "nkenneai-c6551",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "nkenneai-c6551.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "911265560379",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:911265560379:web:54a39eb610efe6b270e91e",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-M55W8ES5R2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics (optional)
export const analytics = getAnalytics(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Authentication Providers
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();

// Optional: Customize provider behavior
googleProvider.setCustomParameters({
  prompt: 'select_account' // Always show account selection
});

// Optional: Request additional GitHub permissions
githubProvider.addScope('user:email');

export default app;